'use strict';

DoohApps
.directive('currentUser', function () {
    return {
        link: function (scope, element) {

            angular.element('body').on('click', function (e) {
                if (!element.is(e.target)
                    && element.has(e.target).length === 0
                    && $('.open').has(e.target).length === 0) {
                    element.removeClass('open');
                }
            });
            element.find('.dropdown-trigger').on('click', function (event) {
                $(this).parent().toggleClass('open');
            });
        }
    }
});